export default __webpack_public_path__ + "static/media/pump-panel.4e8ee27e.jpg";